import { Link as _Link } from 'react-router-dom'
import styled from 'styled-components'

import { applyIPadOnlyStyle } from 'helpers/css'

export const ErrorPageContainer = styled.div`
    width: 70%;
    height: min-content;
    min-height: 35vh;
    background-color: white;
    border-radius: 16px;
    box-sizing: initial;
    padding: 2rem;
    box-shadow: -16px -16px 40px rgba(253, 255, 255, 0.8),
        16px 16px 40px rgba(187, 195, 206, 0.6);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    cursor: default;

    @media (max-width: 700px) {
        flex-direction: column;
        height: 100vh;
        width: 100vw;
        align-content: center;
        background: url('/assets/auth-bg-phone.svg') top center no-repeat,
            url('/assets/auth-bg-phone-bottom.svg') bottom center no-repeat;
        background-size: contain, contain;
        background-color: white;
    }

    @media (max-width: 700px) and (orientation: landscape) {
        flex-direction: row;
    }
`

export const ImageContainer = styled.div`
    flex: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @media (max-width: 700px) {
        justify-content: flex-end;
    }

    @media (max-width: 600px) and (orientation: landscape) {
        justify-content: center;
    }

    ${applyIPadOnlyStyle(
        `
    justify-content: flex-start;
    `,
        {
            min: 300,
            max: 992,
            orientation: 'portrait',
        }
    )}
`

export const Image = styled.img`
    width: 85%;

    @media (max-width: 1366px) {
        width: 100%;
    }
`

export const InnerContainer = styled.div`
    flex: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
`

export const Title = styled.div`
    font-size: 1.7rem;
    font-weight: bold;
    font-family: AvenirBold;
    color: #333333;
    line-height: 120%;

    @media (max-width: 700px) {
        text-align: center;
    }

    @media (max-width: 400px) {
        font-size: 1.4rem;
    }
`

export const Orange = styled.span`
    color: var(--oh-orange);
    margin-right: 5px;
    font-family: AvenirBold;
`

export const Spam = styled.label`
    font-size: 1.3rem;
    color: #828282;
    font-family: AvenirBold;
    margin: 0.5rem 0 30px;

    @media (max-width: 700px) {
        text-align: center;
    }

    @media (max-width: 400px) {
        font-size: 1.1rem;
    }
`

export const ContactUs = styled.a`
    position: fixed;
    right: 2vw;
    bottom: 2vw;
    height: 5vw;
    width: 5vw;
    background: url('/assets/contact-us.svg') center no-repeat;
    background-size: contain;

    @media (max-width: 700px) {
        height: 10vw;
        width: 10vw;
    }
`

export const TryLinkContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    margin: 10px 0;
    font-size: 1.4rem;

    @media (max-width: 700px) {
        text-align: center;
        align-items: center;
        justify-content: center;
    }

    @media (max-width: 400px) {
        font-size: 1.2rem;
    }
`

export const Link = styled.div`
    font-family: Avenir;
    font-weight: normal;
    font-size: 16px;
    color: #555555;
`

export const LinkAnchor = styled(_Link)`
    color: var(--oh-orange);
    margin: 0px 5px;
    font-family: AvenirBold;
    font-weight: 600;
    font-size: 12px;
`

export const CopyImage = styled.img`
    cursor: pointer;
    width: 30px;
    height: auto;
    margin-left: 15px;
`

export const StuckContainer = styled(TryLinkContainer)`
    flex-direction: column;
    align-items: flex-start;

    @media (max-width: 700px) {
        text-align: center;
        align-items: center;
    }
`

export const StuckText = styled.div`
    font-size: 1rem;
    color: #828282;
    font-family: AvenirBold;
    margin: 5px 0;
`

export const ContactButton = styled.a`
    display: flex;
    font-family: AvenirBold;
    justify-content: center;
    align-items: center;
    width: 124px;
    height: 34px;
    font-size: 16px;
    cursor: pointer;
    color: white;
    text-decoration: none;
    background-color: var(--oh-orange);
    border-radius: 5px;

    @media (max-width: 700px) {
        width: 80%;
        height: 50px;
    }
`
